import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import Messenger from "apps/messenger";
import { getStore } from "shared/redux/addToGlobalStore";
import {
	openConversation,
	closeConversation,
} from "ducks/global_messaging";
import { WINDOW_STATE } from "apps/messenger/util/consts";


// STATE
// ------------------------------

const PARENT_ID = "im_footer";
const TARGET_ID = "global_messaging_V2";


// LIB
// ------------------------------

class GlobalMessaging {
	static get store() {
		return getStore();
	}

	static state = {
		isLoaded: false,
	};

	static init() {
		// Already rendered, exit.
		if (this.state.isLoaded) {
			return;
		}

		// Fetch the element to render into.
		const targetElement = this.getTarget();

		if (targetElement) {
			this.state.isLoaded = true;

			render(
				<Provider store={this.store}>
					<Messenger />
				</Provider>,
				targetElement,
			);
		}
	}

	static getTarget() {
		let target = document.getElementById(TARGET_ID);

		// Target doesn't exist yet, create it.
		if (!target) {
			const child = document.createElement("div");
			child.id = TARGET_ID;

			// Add the new element to the parent.
			const parent = document.getElementById(PARENT_ID);

			if (parent) {
				parent.appendChild(child);
				target = child;
			}
		}

		return target;
	}

	static checkReady() {
		if (!this.state.isLoaded) {
			this.init();

			return;
		}

		// Something's not right here.
		if (!this.store || !this.store.getState || !this.store.getState().globalMessaging) {
			throw new Error("Store not initialized!");
		}
	}

	// These hooks are used by legacy non-React code,
	// and ideally should be removed some day.
	// (Do a search for "import GlobalMessaging")

	static openConversation(userid, params = {}) {
		this.checkReady();

		this.store.dispatch(openConversation(userid, params));
	}

	static closeConversation(userid) {
		this.checkReady();

		this.store.dispatch(closeConversation(userid));
	}

	static isConversationOpen(userid) {
		this.checkReady();

		const {
			conversationOrder = [],
			conversationData = {},
		} = this.store.getState().globalMessaging;

		return conversationOrder.indexOf(userid) >= 0 && (
			conversationData[userid] && (
				conversationData[userid].state === WINDOW_STATE.Open
			)
		);
	}

	static isConversationVisible(userid) {
		this.checkReady();

		const {
			conversationOrder = [],
			conversationData = {},
		} = this.store.getState().globalMessaging;

		return conversationOrder.indexOf(userid) >= 0 && (
			conversationData[userid] && (
				conversationData[userid].state === WINDOW_STATE.Open ||
				conversationData[userid].state === WINDOW_STATE.Minimized
			)
		);
	}

	static isConversationOverflowed(userid) {
		this.checkReady();

		const {
			conversationOrder = [],
			conversationData = {},
		} = this.store.getState().globalMessaging;

		return conversationOrder.indexOf(userid) >= 0 && (
			conversationData[userid] && conversationData[userid].state === WINDOW_STATE.Overflow
		);
	}
}

export default GlobalMessaging;



// WEBPACK FOOTER //
// ./src/features/global_messaging/index.js